import { ASESORIAS } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null, 
    ventana_filtros: false, 
    filtros: null, 
    detalles_contacto: null, 
    detalles_nota: null,
    detalles_archivo: null,
    detalles_ahorro: null
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch ( type ) {
        case ASESORIAS.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case ASESORIAS.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case ASESORIAS.ASIGNAR:

            let listado_asignar = state.listado ? state.listado : [];
            listado_asignar.find( asesoria => asesoria._id === payload.id ).asesor = payload.asesor;

            return {
                ...state,
                listado: listado_asignar
            };

        case ASESORIAS.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter( joven => joven._id !== payload.id )
            };

        case ASESORIAS.FILTROS:
            return {
                ...state,
                ventana_filtros: payload
            };

        case ASESORIAS.CONTACTOS.LISTAR:
            return {
                detalles: {
                    ...state.detalles, 
                    informacion_asesoria: {
                        ...state.detalles.informacion_asesoria, 
                        historial: [
                            ...payload
                        ]
                    }
                }
            };

        case ASESORIAS.CONTACTOS.DETALLES:
            return {
                ...state,
                detalles_contacto: payload
            };

        case ASESORIAS.NOTAS.LISTAR:
            return {
                detalles: {
                    ...state.detalles, 
                    informacion_asesoria: {
                        ...state.detalles.informacion_asesoria, 
                        notas: [
                            ...payload
                        ]
                    }
                }
            };

        case ASESORIAS.NOTAS.DETALLES:
            return {
                ...state,
                detalles_nota: payload
            };

        case ASESORIAS.ARCHIVOS.LISTAR:
            return {
                detalles: {
                    ...state.detalles, 
                    informacion_asesoria: {
                        ...state.detalles.informacion_asesoria, 
                        archivos: [
                            ...payload
                        ]
                    }
                }
            };

        case ASESORIAS.ARCHIVOS.DETALLES:
            return {
                ...state,
                detalles_archivo: payload
            };

        case ASESORIAS.AHORROS.LISTAR:
            return {
                detalles: {
                    ...state.detalles,
                    informacion_asesoria: {
                        ...state.detalles.informacion_asesoria,
                        ahorros: [
                            ...payload
                        ]
                    }
                }
            };

        case ASESORIAS.AHORROS.DETALLES:
            return {
                ...state,
                detalles_ahorro: payload
            };

        default:
            return state;
    }
}